__turbopack_context__.v({
  "board": "HorizontalCollapsibleRow-module-scss-module__5M9z2q__board",
  "bulletDot": "HorizontalCollapsibleRow-module-scss-module__5M9z2q__bulletDot",
  "bulletRow": "HorizontalCollapsibleRow-module-scss-module__5M9z2q__bulletRow",
  "bullets": "HorizontalCollapsibleRow-module-scss-module__5M9z2q__bullets",
  "card": "HorizontalCollapsibleRow-module-scss-module__5M9z2q__card",
  "content": "HorizontalCollapsibleRow-module-scss-module__5M9z2q__content",
  "detective": "HorizontalCollapsibleRow-module-scss-module__5M9z2q__detective",
  "link": "HorizontalCollapsibleRow-module-scss-module__5M9z2q__link",
  "naturalLanguage": "HorizontalCollapsibleRow-module-scss-module__5M9z2q__naturalLanguage",
  "open": "HorizontalCollapsibleRow-module-scss-module__5M9z2q__open",
  "portrait": "HorizontalCollapsibleRow-module-scss-module__5M9z2q__portrait",
  "role": "HorizontalCollapsibleRow-module-scss-module__5M9z2q__role",
  "row": "HorizontalCollapsibleRow-module-scss-module__5M9z2q__row",
  "team": "HorizontalCollapsibleRow-module-scss-module__5M9z2q__team",
  "threeLineEllipse": "HorizontalCollapsibleRow-module-scss-module__5M9z2q__threeLineEllipse",
  "title": "HorizontalCollapsibleRow-module-scss-module__5M9z2q__title",
});
